import { routeMappings, SessionStore } from '../../constants';
import { TemplateType } from '../../store/interfaces';

export const handleTCPlusRedirection = (url: string): string => {
  const companySettingsString = sessionStorage.getItem(SessionStore.companySettings);
  const formStatusSession = sessionStorage.getItem(SessionStore.formStatus);
  const templateString = sessionStorage.getItem(SessionStore.template);
  const formStatus = formStatusSession && JSON.parse(formStatusSession);
  const companySettings = companySettingsString && JSON.parse(companySettingsString);
  const template = templateString && JSON.parse(templateString);
  const basicTemplate = template.type === TemplateType.BASIC_EXPERIENCE_LITE;

  const isAnyFormEnabled =
    companySettings.showAppform ||
    companySettings.allowCEBDemographyResearch ||
    companySettings.showEeo ||
    companySettings.enableOfccp ||
    companySettings.showYourResponsiblity;

  if (companySettings && formStatus) {
    //to make sure that we dont enter the welcome page again and again
    if (basicTemplate && !formStatus.welcomePageSubmitted) return routeMappings['WELCOME'];
    // to make sure that we enter task list through welcome page
    else if (
      basicTemplate &&
      formStatus.welcomePageSubmitted &&
      window.location.href.includes(routeMappings['WELCOME'])
    )
      return url;
    else if (companySettings.showAppform && !formStatus.applicationFormSubmitted)
      return routeMappings['APPLICATION_FORM'];
    else if (companySettings.allowCEBDemographyResearch && !formStatus.researchQuestionSubmitted)
      return routeMappings['RESEARCH_QUESTIONS'];
    else if (companySettings.showEeo && !formStatus.eeoSubmitted) return routeMappings['EEO'];
    else if (companySettings.enableOfccp && !formStatus.ofccpSubmitted) return routeMappings['OFCCP'];
    else if (companySettings.showYourResponsiblity && !formStatus.yourResponsibilitySubmitted)
      return routeMappings['YOUR_RESPONSIBILITY'];
    else if (basicTemplate && isAnyFormEnabled) return `${routeMappings['TASK_COMPLETION']}?fromForm=true`;
  }

  return url;
};
